"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = _default;

var _slate = require("slate");

var _slateHelperMarkRemoveall = _interopRequireDefault(require("@canner/slate-helper-mark-removeall"));

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}

function _default(type, currentTextNode, matched, change) {
  var matchedLength = matched[0].length;
  var addText = matched[0].trim().replace(new RegExp(/~/, "g"), "");
  return change.deleteAtRange(_slate.Range.create({
    anchorKey: currentTextNode.key,
    focusKey: currentTextNode.key,
    anchorOffset: matched.index,
    focusOffset: matched.index + matchedLength
  })).insertTextByKey(currentTextNode.key, matched.index, addText, [_slate.Mark.create({
    type: type
  })]).call(_slateHelperMarkRemoveall.default);
}